import React, { useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { Spin } from "antd";

import Page404 from "../../pages/404";
import Header from "../Header.bs";
import LeftPanel from "./LeftPanel";
import RightPanel from "./RightPanel";
import CCAvenueForm from "./CCAvenueForm";

import { fetchItem } from "../../store/actions/checkout-actions";

const Checkout = ({ itemId }) => {
  const dispatch = useDispatch();
  const rightPanelPaymentBtn = useRef(null);
  const location = useLocation();

  const [item, loading] = useSelector((state) => [state.checkout.item, state.checkout.loading]);
  // const stream = useSelector((state) => state.home.utm?.stream); // this causes stale state case
  const ccaForm = useSelector((state) => state.checkout.ccaForm);

  const query = new URLSearchParams(location.search);
  const stream = query.get("utm_stream") || null; // fix for stale state - fetch updated value from query directly

  useEffect(() => {
    if (itemId) dispatch(fetchItem(itemId, stream));
  }, [dispatch, itemId, stream]);

  const scrollToPayment = (toRef) => {
    if (toRef) toRef.current.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
      {!itemId ? (
        <Page404 type="404" />
      ) : (
        <>
          {loading ? (
            <Spin size="large" className="loadingSpinner" />
          ) : (
            <>
              {ccaForm ? (
                <CCAvenueForm
                  formActionUrl={ccaForm.formActionUrl}
                  encryptedData={ccaForm.encRequest}
                  access_code={ccaForm.accessCode}
                />
              ) : item ? (
                <>
                  <Header />

                  <section className="section py-lg-8 py-md-4 py-4">
                    <div className="container d-flex flex-column">
                      <div className="row justify-content-center no-gutters">
                        <LeftPanel item={item} />

                        <button
                          className="btn btn-block btn-primary mb-6 scrollToPaymentBtn"
                          type="button"
                          onClick={() => scrollToPayment(rightPanelPaymentBtn)}
                        >
                          Click to Pay now!
                        </button>

                        <RightPanel item={item} fwdRef={rightPanelPaymentBtn} />
                      </div>
                    </div>
                  </section>
                </>
              ) : (
                <Page404 type="404" />
              )}
            </>
          )}
        </>
      )}
    </>
  );
};

export default Checkout;
